import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (
  filter: Filter,
  insights: (InsightData & { levelOneFilter?: string })[]
) => ({
  ...filter,
  genders: insights.map((insight) => insight.levelOneFilter || insight.name)
})

const generateGendersStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateGendersStrategy
